<template>
  <v-snackbar
    auto-height
    v-model="snackbar"
    :top="$vuetify.breakpoint.mdAndUp"
    :right="$vuetify.breakpoint.mdAndUp"
    :bottom="$vuetify.breakpoint.smAndDown"
    :timeout="getSnackBarTimeout"
    :color="getSnackBarColor"
    class="text-xs-left"
  >
    <v-layout xs12 row align-center justify-space-between>
      <span class="text-xs-left" v-html="getSnackBarText"></span>

      <v-btn flat @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </v-snackbar>
</template>

<style>
  .share {
    background: url("/owa/img/icons/ios-share.png") no-repeat center center;
  }

  .share-prod {
    background: url("/owa/img/icons/ios-share.png") no-repeat center center;
  }

  .share-prod,
  .share {
    background-size: contain;
    display: inline-block;
    height: 25px;
    width: 25px;
  }

  .add-to-home {
    height: 25px;
    width: 25px;
    color: #000;
  }
</style>
<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'getSnackBarColor',
        'getSnackBarText',
        'getSnackBarHtml',
        'getSnackBarTimeout'
      ]),
      snackbar: {
        get() {
          return this.$store.state.snackbar.isVisible
        },
        set(val) {
          this.$store.commit('UPDATE_VISIBILITY', val)
        }
      }
    },
    data() {
      return {
        timeout: 8000
      }
    }
  }
</script>
